function defaultValueProp(e, defaultValue) {
  e.target.value = e.target.defaultValue;
}

// product-tags.liquid countdowns

document.addEventListener("DOMContentLoaded", function () {
  const countdownElements = document.querySelectorAll(
    ".product--tag_countdown"
  );

  if (countdownElements != null) {
    function updateCountdown() {
      const now = Math.floor(new Date().getTime() / 1000);
      countdownElements.forEach(function (element) {
        const countdownTime = parseInt(
          element.getAttribute("data-countdown-time")
        );
        const distance = countdownTime - now;
        if (distance > 0) {
          const days = Math.floor(distance / (60 * 60 * 24));
          const hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
          const minutes = Math.floor((distance % (60 * 60)) / 60);
          const seconds = Math.floor(distance % 60);
          element.querySelector(".countdown-timer").innerHTML =
            days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
        } else {
          element.style.display = "none";
        }
      });
    }

    setInterval(updateCountdown, 1000);
    updateCountdown();
  }
});

/* ---------------------------------------------------------------------------------------------------------------------
 * PURCHASE LIMIT (metafield de producto custom.limitar_compra)
 * ---------------------------------------------------------------------------------------------------------------------
 * Límite de unidades por PRODUCTO (suma de todas sus variantes en el carrito). Capas:
 *   1. Liquid (snippets/purchase-limit.liquid): max del input, botones deshabilitados en el render inicial.
 *   2. validateAdd(): pre-check antes de cada cart/add.js del ProductForm (PDP, quick-add, card). Lo llama theme.js.
 *   3. syncProductUI(): tras cada mutación del carrito, recalcula max/estado de botones en la página sin recargar.
 *   4. enforceCart(): tras cada mutación (y al cargar la página) revisa el carrito y, si algún producto limitado
 *      supera su límite (p. ej. añadido por otra vía), recorta las líneas con cart/update.js.
 * OJO: es una protección de tema (UX). No impide llamadas directas a la Cart API ni permalinks en checkout.
 * ------------------------------------------------------------------------------------------------------------------- */
(() => {
  const SECTION_ID = "purchase-limits";
  const NOTICE_STORAGE_KEY = "purchase-limit-notice";
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const strings = () => (window.themeVariables && window.themeVariables.strings) || {};
  const pageType = () => window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;

  let isCorrecting = false;

  const fetchCart = async () => (await fetch(`${root()}cart.js`, { headers: { Accept: "application/json" } })).json();

  const quantityInCart = (cart, productId) =>
    (cart.items || [])
      .filter((item) => String(item.product_id) === String(productId))
      .reduce((sum, item) => sum + item.quantity, 0);

  const parseLimits = (source) => {
    try {
      const container = typeof source === "string" ? new DOMParser().parseFromString(source, "text/html") : source;
      const script = container && container.querySelector("script[data-purchase-limits]");
      return script ? JSON.parse(script.textContent.trim() || "{}") : {};
    } catch (error) {
      console.error("[PurchaseLimit] No se pudieron leer los límites", error);
      return {};
    }
  };

  const fetchLimits = async () => {
    const response = await fetch(`${root()}?sections=${SECTION_ID}`);
    return parseLimits((await response.json())[SECTION_ID]);
  };

  function notify(message) {
    if (!message) return;
    const banner = document.createElement("div");
    banner.className = "banner banner--error purchase-limit-toast";
    banner.setAttribute("role", "alert");
    banner.textContent = message;
    Object.assign(banner.style, {
      position: "fixed",
      insetInline: "16px",
      bottom: "16px",
      marginInline: "auto",
      maxWidth: "480px",
      zIndex: "2147483000"
    });
    document.body.appendChild(banner);
    setTimeout(() => banner.remove(), 4000);
  }

  /* ---------- 2. Pre-check al añadir ---------- */

  async function validateAdd(form) {
    const limit = parseInt(form.dataset.purchaseLimit, 10);
    const productId = form.dataset.productId;

    if (!limit || limit <= 0 || !productId) return true;

    const requested = parseInt(new FormData(form).get("quantity"), 10) || 1;
    let cart;

    try {
      cart = await fetchCart();
    } catch (error) {
      return true; // Si no podemos leer el carrito, no bloqueamos (el guard del carrito corregirá después)
    }

    const remaining = Math.max(limit - quantityInCart(cart, productId), 0);

    if (requested <= remaining) return true;

    const message = remaining === 0
      ? (strings().purchaseLimitError || "").replace("[limit]", limit)
      : (strings().purchaseLimitRemainingError || "").replace("[units]", remaining);

    // Reutiliza el banner de error de <buy-buttons>; en las cards (sin buy-buttons) usamos el toast
    if (document.querySelector(`buy-buttons[form="${CSS.escape(form.id)}"]`)) {
      form.dispatchEvent(new CustomEvent("cart:error", { bubbles: true, detail: { error: message } }));
    } else {
      notify(message);
    }

    syncProductUI(cart);
    return false;
  }

  /* ---------- 3. Sincronización de la UI de producto ---------- */

  function syncProductUI(cart) {
    // Inputs de cantidad de producto (PDP / quick-add). Los de línea de carrito se re-renderizan desde servidor.
    document.querySelectorAll("input[data-purchase-limit]:not([data-line-key])").forEach((input) => {
      const limit = parseInt(input.dataset.purchaseLimit, 10);
      const remaining = Math.max(limit - quantityInCart(cart, input.dataset.productId), 0);

      input.disabled = remaining === 0;
      input.max = Math.max(remaining, 1);
      if (input.quantity > input.max) input.value = input.max;
      updateSelectorButtons(input);
    });

    document.querySelectorAll("form[data-purchase-limit]").forEach((form) => {
      const limit = parseInt(form.dataset.purchaseLimit, 10);
      if (!limit || limit <= 0) return;

      const reached = quantityInCart(cart, form.dataset.productId) >= limit;
      const buyButtons = form.id ? document.querySelector(`buy-buttons[form="${CSS.escape(form.id)}"]`) : null;

      if (buyButtons) {
        const button = buyButtons.querySelector('button[type="submit"]');
        const paymentButton = buyButtons.querySelector(".shopify-payment-button");

        if (reached) {
          buyButtons.setAttribute("purchase-limit-reached", "");
          // Solo tocamos el botón si estaba activo (si está agotado, mantenemos su estado)
          if (button && !button.disabled) {
            button.disabled = true;
            button.innerHTML = strings().purchaseLimitReachedButton;
          }
          if (paymentButton) paymentButton.style.display = "none";
        } else if (buyButtons.hasAttribute("purchase-limit-reached")) {
          buyButtons.removeAttribute("purchase-limit-reached");
          // Solo reactivamos si estaba deshabilitado por el límite (no por falta de stock)
          if (button && button.textContent.trim() === (strings().purchaseLimitReachedButton || "").trim()) {
            button.disabled = false;
            button.innerHTML = (buyButtons.getAttribute("template") || "").includes("pre-order")
              ? strings().preOrderButton
              : strings().addToCartButton;
            if (paymentButton) paymentButton.style.display = "";
          }
        }
      } else {
        // Card de producto de variante única
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;

        if (reached && !button.disabled) {
          button.disabled = true;
          button.setAttribute("data-limit-disabled", "");
        } else if (!reached && button.hasAttribute("data-limit-disabled")) {
          button.disabled = false;
          button.removeAttribute("data-limit-disabled");
        }
      }
    });
  }

  function updateSelectorButtons(input) {
    const selector = input.closest("quantity-selector");
    if (!selector) return;

    const decrease = selector.querySelector("button:first-of-type");
    const increase = selector.querySelector("button:last-of-type");
    const max = parseInt(input.max, 10);
    const value = parseInt(input.value, 10) || 1;

    if (increase && increase !== decrease) increase.disabled = input.disabled || (!isNaN(max) && value >= max);
    if (decrease && input.disabled) decrease.disabled = true;
  }

  // Clamp al escribir / al pulsar +/- en inputs de producto limitados
  const onProductQuantityInteraction = (event) => {
    const selector = event.target.closest && event.target.closest("quantity-selector");
    const input = selector && selector.querySelector("input[data-purchase-limit]:not([data-line-key])");
    if (!input) return;

    // Tras el click, QuantitySelector ya ha hecho stepUp/stepDown
    requestAnimationFrame(() => {
      const max = parseInt(input.max, 10);
      if (!isNaN(max) && (parseInt(input.value, 10) || 1) > max) input.value = max;
      updateSelectorButtons(input);
    });
  };

  document.addEventListener("click", onProductQuantityInteraction);
  document.addEventListener("input", onProductQuantityInteraction);

  /* ---------- 4. Guard del carrito ---------- */

  function computeUpdates(cart, limits) {
    const updates = {};
    const byProduct = {};

    (cart.items || []).forEach((item) => {
      if (!limits[item.product_id]) return;
      (byProduct[item.product_id] = byProduct[item.product_id] || []).push(item);
    });

    Object.keys(byProduct).forEach((productId) => {
      const items = byProduct[productId];
      let excess = items.reduce((sum, item) => sum + item.quantity, 0) - limits[productId];

      // Recortamos empezando por las últimas líneas añadidas (el carrito las devuelve primero, así que vamos en orden)
      for (const item of items) {
        if (excess <= 0) break;
        const reduceBy = Math.min(excess, item.quantity);
        updates[item.key] = item.quantity - reduceBy;
        excess -= reduceBy;
      }
    });

    return updates;
  }

  async function enforceCart(cart, limits) {
    if (isCorrecting || !cart || !cart.items || cart.items.length === 0) return;

    try {
      isCorrecting = true;
      limits = limits || await fetchLimits();

      if (Object.keys(limits).length === 0) return;

      const updates = computeUpdates(cart, limits);
      if (Object.keys(updates).length === 0) return;

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

      const response = await fetch(`${root()}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates, sections: sectionsToBundle.filter((id) => id !== SECTION_ID).join(",") })
      });

      if (!response.ok) throw new Error(`cart/update.js ${response.status}`);

      const newCart = await response.json();

      if (pageType() === "cart") {
        // El carrito de página funciona con recargas completas
        try { sessionStorage.setItem(NOTICE_STORAGE_KEY, "1"); } catch (error) {}
        window.location.reload();
        return;
      }

      notify(strings().purchaseLimitCartAdjusted);
      syncProductUI(newCart);

      // isCorrecting sigue a true: el cart:change que emitimos no vuelve a disparar la corrección
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "purchase-limit:adjust", cart: newCart }
      }));
    } catch (error) {
      console.error("[PurchaseLimit] Error validando el carrito", error);
    } finally {
      isCorrecting = false;
    }
  }

  // Pedimos la sección de límites junto a cada mutación del tema (add / change) para ahorrar una petición
  document.addEventListener("cart:prepare-bundled-sections", (event) => {
    if (!isCorrecting && !event.detail.sections.includes(SECTION_ID)) event.detail.sections.push(SECTION_ID);
  });

  document.addEventListener("cart:change", (event) => {
    const cart = event.detail && event.detail.cart;
    if (!cart || isCorrecting) return;

    syncProductUI(cart);

    const bundled = cart.sections && cart.sections[SECTION_ID];
    enforceCart(cart, bundled ? parseLimits(bundled) : null);
  });

  // cart:refresh lo emiten scripts que mutan el carrito por su cuenta (p. ej. recomendaciones del cart drawer)
  document.addEventListener("cart:refresh", async () => {
    if (isCorrecting) return;
    try {
      const cart = await fetchCart();
      syncProductUI(cart);
      enforceCart(cart);
    } catch (error) {}
  });

  // Carga inicial: el layout ya trae los límites de los productos del carrito
  document.addEventListener("DOMContentLoaded", async () => {
    try {
      if (sessionStorage.getItem(NOTICE_STORAGE_KEY)) {
        sessionStorage.removeItem(NOTICE_STORAGE_KEY);
        notify(strings().purchaseLimitCartAdjusted);
      }
    } catch (error) {}

    const limits = parseLimits(document);
    if (Object.keys(limits).length === 0) return;

    try {
      enforceCart(await fetchCart(), limits);
    } catch (error) {}
  });

  // Back-forward cache: el estado de la página puede estar obsoleto
  window.addEventListener("pageshow", async (event) => {
    if (!event.persisted) return;
    try {
      const cart = await fetchCart();
      syncProductUI(cart);
      enforceCart(cart);
    } catch (error) {}
  });

  window.PurchaseLimit = { validateAdd, syncProductUI, enforceCart };
})();
